import { render, staticRenderFns } from "./InsurerSideMenu.vue?vue&type=template&id=1cb9048d&scoped=true"
import script from "./InsurerSideMenu.vue?vue&type=script&lang=js"
export * from "./InsurerSideMenu.vue?vue&type=script&lang=js"
import style0 from "./InsurerSideMenu.vue?vue&type=style&index=0&id=1cb9048d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb9048d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cb9048d')) {
      api.createRecord('1cb9048d', component.options)
    } else {
      api.reload('1cb9048d', component.options)
    }
    module.hot.accept("./InsurerSideMenu.vue?vue&type=template&id=1cb9048d&scoped=true", function () {
      api.rerender('1cb9048d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurer/InsurerSideMenu.vue"
export default component.exports